<template>
  <div v-if="renderReady">
    <label v-if="getTitle">
      <template v-if="!setTitleAsPlaceholder">{{getTitle}}</template>
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{tooltipContent}}</w-tooltip>
    </label>
    <div class>
      <div class="input-group-prepend" v-if="prependicon">
        <span class="input-group-text">
          <i
            class="icon-prepend fa"
            v-if="prependicon"
            :class="prependicon.startsWith('fa-') ? prependicon : ''"
          >{{prependicon.startsWith('fa-') ? '' : prependicon}}</i>
        </span>
      </div>
      <input
        :placeholder="getPlaceholder"
        ref="input"
        :type="type"
        class="form-control"
        :class="{'borderless':borderless, 'text-right': textRight, 'is-invalid': this.model.$error}"
        :style="appendiconTextRight"
        :disabled="disabled"
        :readonly="model.$schema.readOnly"
        :value="svalue"
        @input="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        @mouseover="mouseOver($event)"
        @mouseleave="mouseOut($event)"
        :id="model.$form.generateId ? model.$pathId : undefined"
        :name="model.$form.testPath ? model.$path : undefined"
      />
      <div class="input-group-append" v-if="prependicon">
        <span class="input-group-text">
          <i
            class="icon-append fa"
            v-if="appendicon"
            :class="appendicon.startsWith('fa-') ? appendicon : ''"
          >{{appendicon.startsWith('fa-') ? '' : appendicon}}</i>
        </span>
      </div>
      <w-error v-if="showError" :model="model" @focus="$refs.input.focus();"></w-error>
    </div>
  </div>
</template>

<script>
//         v-tooltip.notrigger="{content: tooltipContent, visible: !getTitle && tooltipVisibility}"

import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-input',
  components: {WError, WTooltip},
  props: {
    placeholder: String,
    type: {
      type: String,
      default: 'text'
    },
    appendicon: {
      type: String,
      default: ''
    },
    prependicon: {
      type: String,
      default: ''
    },
    setTitleAsPlaceholder: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: true
    }
  },
  mixins: [modelMixin],
  data() {
    return {
      placeHolder: ''
    };
  },
  computed: {
    textRight() {
      return this.model.$schema.type === 'number' || this.model.$schema.type === 'money' || this.model.$schema.type === 'integer';
    },
    appendiconTextRight() {
      return this.textRight && this.appendicon ? {paddingRight: '35px!important'} : {};
    },
    getPlaceholder() {
      this.placeHolder = this.placeholder;
      if (this.setTitleAsPlaceholder) {
        this.placeHolder = this.getTitle;
        return this.placeHolder;
      } else {
        return this.placeHolder;
      }
    }
  },
  methods: {}
};
</script>

<style>
</style>